import { TextFieldLoadingState } from '../TextFieldLoadingState/TextFieldLoadingState'
import Styles from './BlogPostWizard.module.scss'

export const LinksLoadingState = ({ count }: { count: number }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div className={Styles.linkInputsContainer} key={index}>
          <TextFieldLoadingState />
        </div>
      ))}
    </>
  )
}
